var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClassroom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeMiterlimit: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0.672513,0.57051)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.785894,0,0,0.785894,-0.511565,0.533748)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-5.69357,-7.50709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,20C18.761,20 21,17.761 21,15C21,12.239 18.761,10 16,10C13.239,10 11,12.239 11,15C11,17.761 13.239,20 16,20Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(17,17,17)",
      strokeWidth: "1.27px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-5.69357,-7.50709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.975,24.922C8.728,23.441 9.877,22.197 11.293,21.328C12.709,20.46 14.338,20 16,20C17.662,20 19.291,20.46 20.707,21.328C22.123,22.197 23.272,23.441 24.025,24.922",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(17,17,17)",
      strokeWidth: "1.27px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.785894,0,0,0.785894,-0.511565,14.6799)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-5.69357,-7.50709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,20C18.761,20 21,17.761 21,15C21,12.239 18.761,10 16,10C13.239,10 11,12.239 11,15C11,17.761 13.239,20 16,20Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(17,17,17)",
      strokeWidth: "1.27px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-5.69357,-7.50709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.975,24.922C8.728,23.441 9.877,22.197 11.293,21.328C12.709,20.46 14.338,20 16,20C17.662,20 19.291,20.46 20.707,21.328C22.123,22.197 23.272,23.441 24.025,24.922",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(17,17,17)",
      strokeWidth: "1.27px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.785894,0,0,0.785894,14.9671,0.533748)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-5.69357,-7.50709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,20C18.761,20 21,17.761 21,15C21,12.239 18.761,10 16,10C13.239,10 11,12.239 11,15C11,17.761 13.239,20 16,20Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(17,17,17)",
      strokeWidth: "1.27px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-5.69357,-7.50709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.975,24.922C8.728,23.441 9.877,22.197 11.293,21.328C12.709,20.46 14.338,20 16,20C17.662,20 19.291,20.46 20.707,21.328C22.123,22.197 23.272,23.441 24.025,24.922",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(17,17,17)",
      strokeWidth: "1.27px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.785894,0,0,0.785894,14.9671,14.6799)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-5.69357,-7.50709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,20C18.761,20 21,17.761 21,15C21,12.239 18.761,10 16,10C13.239,10 11,12.239 11,15C11,17.761 13.239,20 16,20Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(17,17,17)",
      strokeWidth: "1.27px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-5.69357,-7.50709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.975,24.922C8.728,23.441 9.877,22.197 11.293,21.328C12.709,20.46 14.338,20 16,20C17.662,20 19.291,20.46 20.707,21.328C22.123,22.197 23.272,23.441 24.025,24.922",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(17,17,17)",
      strokeWidth: "1.27px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassroom);
export default __webpack_public_path__ + "static/media/classroom.7d4a7644e15b4077b152bc44e9fcf43e.svg";
export { ForwardRef as ReactComponent };